import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface IBanner {
  id: number;
  title: string;
  subtitle: string;
  imageUrl: string;
  buttonText: string;
  buttonUrl: string;
  order: number;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private readonly BASE_URL: string = environment.BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getActiveBanners(): Observable<IBanner[]> {
    return this.http.get<any>(`${this.BASE_URL}/home-banners/active`).pipe(
      map((response) => {
        const items = response?.data ?? response ?? [];
        return Array.isArray(items) ? items : [];
      })
    );
  }
}
